import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  CATEGORY,
  COUNTRY,
  DISCLOSURE,
  REQUIRED_BY,
  SOURCE,
} from 'constants/formFields';
import { DEFAULT_OPTION } from 'constants/general';
import { disclosuresCreateSchema } from 'utils/validators';

import type { TDisclosuresCreateSchema } from 'utils/validators';
import type ICreateQuestionForm from '../interfaces/ICreateQuestionForm';

const useCreateQuestionForm = ({ isPageLoading }: ICreateQuestionForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TDisclosuresCreateSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(disclosuresCreateSchema),
    defaultValues: {
      [DISCLOSURE]: '',
      [CATEGORY]: DEFAULT_OPTION,
      [COUNTRY]: DEFAULT_OPTION,
      [REQUIRED_BY]: '',
      [SOURCE]: '',
    },
  });

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    resetField,
  };
};

export default useCreateQuestionForm;
